/* eslint-disable complexity */
import { useState } from "react";

import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { Logo } from "../../../../libraries/wpl/foundations/src/index";

//Types
type ProductType =
    | "atlas"
    | "compass"
    | "confluence"
    | "jiraproductdiscovery"
    | "jiraservicemanagement"
    | "jirasoftware"
    | "trello";

interface ProductNames {
    atlas: string;
    compass: string;
    confluence: string;
    jiraproductdiscovery: string;
    jiraservicemanagement: string;
    jirasoftware: string;
    trello: string;
}

const Products: ProductNames = {
    atlas: "Atlas",
    compass: "Compass",
    confluence: "Confluence",
    jiraproductdiscovery: "Jira Product Discovery",
    jiraservicemanagement: "Jira Service Management",
    jirasoftware: "Jira Software",
    trello: "Trello"
};

export interface ProductDetails {
    href: string;
    product: ProductType;
    description: string;
}

export interface ProductCardProps {
    productDetails: ProductDetails;
    className?: string;
    testId?: string;
}

export const ProductCard = ({
    productDetails,
    className,
    testId
}: ProductCardProps) => {
    const [isMouseOver, setMouseOver] = useState(false);

    const panelStyle = css({
        marginBlockEnd: token("space.250")
    });
    // TODO: adjust logo sizing when support is added for it
    const iconStyle = [
        isMouseOver &&
            css({
                backgroundColor: "#c1c7d0",
                marginInlineEnd: token("space.250"),
                borderRadius: token("space.025"),
                padding: `${token("space.050")} ${token("space.050")} 0 ${token(
                    "space.050"
                )}`
            }),
        !isMouseOver &&
            css({
                backgroundColor: "#dfe1e5",
                marginInlineEnd: token("space.250"),
                borderRadius: token("space.025"),
                padding: `${token("space.050")} ${token("space.050")} 0 ${token(
                    "space.050"
                )}`
            })
    ];

    const titleStyle = [
        isMouseOver &&
            css({
                color: "#0052cc",
                fontSize: token("space.200")
            }),
        !isMouseOver &&
            css({
                color: "#091e42",
                fontSize: token("space.200")
            })
    ];

    const descriptionStyle = css({
        color: "#505f79",
        fontSize: token("space.150")
    });

    return (
        <div className={className} css={panelStyle}>
            <a
                href={productDetails.href}
                target={productDetails.product === "trello" ? "_blank" : ""}
                rel="noreferrer"
                data-event="clicked"
                data-event-component="linkButton"
                data-event-container="globalNavWacDropdownContainer"
            >
                <div
                    onMouseEnter={() => setMouseOver(true)}
                    onMouseLeave={() => setMouseOver(false)}
                    css={css({
                        display: "inline-flex",
                        alignItems: "center"
                    })}
                    data-testid={testId}
                >
                    <div css={iconStyle} data-testid="icon">
                        <Logo
                            brand={productDetails.product}
                            type="mark"
                            appearance="brand"
                        />
                    </div>
                    <div>
                        <div css={titleStyle} data-testid="title">
                            {Products[productDetails.product]}
                        </div>
                        <div css={descriptionStyle}>
                            {productDetails.description}
                        </div>
                    </div>
                </div>
            </a>
        </div>
    );
};
